import { useContext } from 'react';
import { ThemeContext } from './ThemeProvider';
const useTheme = () => {
  const theme = useContext(ThemeContext);
  // Fail fast if dev uses useTheme outside of ThemeProvider
  if (theme instanceof Error) {
    throw theme;
  }
  return theme;
};
export default useTheme;